'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactApollo = require('react-apollo');

var _reactRouterDom = require('react-router-dom');

var _reactRouterRedux = require('react-router-redux');

var _reactRedux = require('react-redux');

var _Loading = require('../utility/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _session = require('../../redux/actions/session');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new _promise2.default(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return _promise2.default.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createAuthenticatedRoute = function createAuthenticatedRoute(_ref) {
  var userQuery = _ref.userQuery,
      getUserFromData = _ref.getUserFromData;

  var AuthenticatedRoute = function AuthenticatedRoute(_ref2) {
    var Component = _ref2.component,
        otherProps = _objectWithoutProperties(_ref2, ['component']);

    var AuthenticatedComponent = function (_React$Component) {
      _inherits(AuthenticatedComponent, _React$Component);

      function AuthenticatedComponent() {
        _classCallCheck(this, AuthenticatedComponent);

        return _possibleConstructorReturn(this, (AuthenticatedComponent.__proto__ || (0, _getPrototypeOf2.default)(AuthenticatedComponent)).apply(this, arguments));
      }

      _createClass(AuthenticatedComponent, [{
        key: 'componentDidMount',
        value: function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var _props, client, dispatch, isAuthenticated, isAuthenticating, _ref4, data, user;

            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _props = this.props, client = _props.client, dispatch = _props.dispatch, isAuthenticated = _props.isAuthenticated, isAuthenticating = _props.isAuthenticating;

                    if (isAuthenticated) {
                      _context.next = 18;
                      break;
                    }

                    if (!isAuthenticating) {
                      dispatch((0, _session.authenticatingAction)());
                    }

                    _context.prev = 3;
                    _context.next = 6;
                    return client.query({
                      query: userQuery,
                      fetchPolicy: 'network-only'
                    });

                  case 6:
                    _ref4 = _context.sent;
                    data = _ref4.data;
                    user = getUserFromData(data);


                    dispatch((0, _session.authenticatedAction)(user));
                    _context.next = 18;
                    break;

                  case 12:
                    _context.prev = 12;
                    _context.t0 = _context['catch'](3);

                    localStorage.removeItem('authToken');
                    if (window.location.pathname.indexOf('/offer/') === 0) {
                      localStorage.setItem('desiredRoute', window.location.pathname);
                    }

                    dispatch((0, _session.authenticateFailureAction)());
                    dispatch((0, _reactRouterRedux.push)('/login'));

                  case 18:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this, [[3, 12]]);
          }));

          function componentDidMount() {
            return _ref3.apply(this, arguments);
          }

          return componentDidMount;
        }()
      }, {
        key: 'render',
        value: function render() {
          var _props2 = this.props,
              isFirstAuthentication = _props2.isFirstAuthentication,
              isAuthenticated = _props2.isAuthenticated,
              isAuthenticating = _props2.isAuthenticating,
              location = _props2.location;


          if (!isAuthenticated) {
            if (isFirstAuthentication || isAuthenticating) {
              return _react2.default.createElement(_Loading2.default, null);
            }

            // TODO: Implement redirect after successful login
            return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/login?redirect=' + location.pathname });
          }

          return _react2.default.createElement(Component, this.props);
        }
      }]);

      return AuthenticatedComponent;
    }(_react2.default.Component);

    AuthenticatedComponent.propTypes = {
      client: _propTypes2.default.object.isRequired,
      dispatch: _propTypes2.default.func.isRequired,
      isFirstAuthentication: _propTypes2.default.bool.isRequired,
      isAuthenticated: _propTypes2.default.bool.isRequired,
      isAuthenticating: _propTypes2.default.bool.isRequired,
      location: _propTypes2.default.object.isRequired
    };


    var AuthenticatedComponentWithData = (0, _reactRedux.connect)(function (_ref5) {
      var session = _ref5.session;
      return _extends({}, session);
    })((0, _reactApollo.withApollo)(AuthenticatedComponent));

    return _react2.default.createElement(_reactRouterDom.Route, _extends({}, otherProps, { component: AuthenticatedComponentWithData }));
  };

  AuthenticatedRoute.propTypes = {
    component: _propTypes2.default.any.isRequired
  };

  return AuthenticatedRoute;
};

exports.default = createAuthenticatedRoute;